import { Link } from "react-router-dom";
import { Instagram, Facebook, Twitter, Mail, Phone } from "lucide-react";

export default function Footer() {
  return (
    <footer className="bg-neutral-950 text-neutral-300 mt-24">
      <div className="max-w-7xl mx-auto px-6 lg:px-10 py-16 grid gap-12 md:grid-cols-4">
        <div className="md:col-span-2 space-y-4">
          <div className="flex items-center gap-3">
            <img
              src="https://customer-assets-0z36b82j.emergentagent.net/job_sandar-eats/artifacts/v9aauz8h_sandar-logo.png"
              alt="Sandar Sushi"
              className="h-14 w-auto object-contain bg-white/95 rounded-lg p-2"
            />
          </div>
          <p className="max-w-md text-neutral-400 leading-relaxed">
            Fresh sushi and Japanese favorites, chef-rolled daily. Proudly serving our military communities. Freshness in Every Bite.
          </p>
          <div className="flex gap-3 pt-2">
            <a href="#" className="w-9 h-9 rounded-full border border-neutral-800 flex items-center justify-center hover:border-[hsl(var(--primary))] hover:text-[hsl(var(--primary))] transition-colors"><Instagram className="w-4 h-4"/></a>
            <a href="#" className="w-9 h-9 rounded-full border border-neutral-800 flex items-center justify-center hover:border-[hsl(var(--primary))] hover:text-[hsl(var(--primary))] transition-colors"><Facebook className="w-4 h-4"/></a>
            <a href="#" className="w-9 h-9 rounded-full border border-neutral-800 flex items-center justify-center hover:border-[hsl(var(--primary))] hover:text-[hsl(var(--primary))] transition-colors"><Twitter className="w-4 h-4"/></a>
          </div>
        </div>
        <div>
          <h4 className="font-display font-semibold text-white mb-4">Explore</h4>
          <ul className="space-y-2 text-sm">
            <li><Link to="/menu" className="hover:text-white">Menu</Link></li>
            <li><Link to="/locations" className="hover:text-white">Locations</Link></li>
            <li><Link to="/markets" className="hover:text-white">Markets</Link></li>
            <li><Link to="/story" className="hover:text-white">Our Story</Link></li>
            <li><Link to="/careers" className="hover:text-white">Careers</Link></li>
            <li><Link to="/account" className="hover:text-white">Account</Link></li>
          </ul>
        </div>
        <div>
          <h4 className="font-display font-semibold text-white mb-4">Contact</h4>
          <ul className="space-y-3 text-sm">
            <li><a href="tel:7182162013" className="flex items-center gap-2 hover:text-white" data-testid="footer-phone"><Phone className="w-3.5 h-3.5 text-[hsl(var(--primary))]"/>718-216-2013</a></li>
            <li><a href="mailto:info@sandarsushi.com" className="flex items-center gap-2 hover:text-white break-all" data-testid="footer-info-email"><Mail className="w-3.5 h-3.5 text-[hsl(var(--primary))]"/>info@sandarsushi.com</a></li>
            <li><a href="mailto:htet@sandarsushi.com" className="flex items-center gap-2 hover:text-white break-all" data-testid="footer-htet-email"><Mail className="w-3.5 h-3.5 text-[hsl(var(--primary))]"/>htet@sandarsushi.com</a></li>
            <li className="text-neutral-500 pt-1">Mon – Sun: 9:00 AM – 6:00 PM ET</li>
          </ul>
        </div>
      </div>
      <div className="border-t border-neutral-900">
        <div className="max-w-7xl mx-auto px-6 lg:px-10 py-8">
          <h4 className="font-display text-xl font-bold tracking-tight text-white">
            Legal & Customer Support
          </h4>
          <nav
            className="mt-4 flex flex-wrap gap-x-5 gap-y-3 text-sm text-neutral-400"
            aria-label="Legal and customer support"
            data-testid="footer-legal-links"
          >
            <Link to="/privacy-policy" className="hover:text-white" data-testid="footer-privacy-policy">
              Privacy Policy
            </Link>
            <Link to="/terms" className="hover:text-white" data-testid="footer-terms">
              Terms & Conditions
            </Link>
            <Link to="/ordering-policy" className="hover:text-white" data-testid="footer-ordering-policy">
              Ordering & Refunds
            </Link>
            <Link to="/food-allergens" className="hover:text-white" data-testid="footer-food-allergens">
              Food Allergens
            </Link>
            <Link
              to="/location-disclaimer"
              className="hover:text-white"
              data-testid="footer-location-disclaimer"
            >
              Location Disclaimer
            </Link>
            <Link to="/accessibility" className="hover:text-white" data-testid="footer-accessibility">
              Accessibility
            </Link>
          </nav>
        </div>
      </div>
      <div className="border-t border-neutral-900 px-6 lg:px-10 py-6 max-w-7xl mx-auto flex flex-col md:flex-row items-center justify-between text-xs text-neutral-500">
        <p>© {new Date().getFullYear()} Sandar Sushi. All rights reserved.</p>
        <p>Freshness in Every Bite.</p>
      </div>
    </footer>
  );
}
